import React from 'react'
import Login from '../pages/Auth/Login/Index'
import ForgotPassword from '../pages/Auth/ForgotPassword/Index'
import OTP from '../pages/Auth/OTP/Index'
import { Route } from 'react-router-dom'
import Test from '../Test'

const PublicRoutes = (
    <>
        <Route path='/login' element={<Login />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/otp' element={<OTP />} />
        <Route path='/test' element={<Test />} />
    </>
)




export default PublicRoutes